// Email: “something@something.tld” (basic sanity check)
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
// Same pattern but as a plain string for <input pattern> (no flags allowed there)
export const EMAIL_HTML_PATTERN = "^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$";

// Password: 8–64 chars, at least 1 lowercase, 1 uppercase, 1 digit, 1 symbol
export const PASS_RE =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,64}$/;

// Optional: granular feedback for tooltips/inline help
export function passwordIssues(pw: string): string[] {
  const issues: string[] = [];
  if (pw.length < 8 || pw.length > 64) issues.push("8–64 characters");
  if (!/[a-z]/.test(pw)) issues.push("a lowercase letter");
  if (!/[A-Z]/.test(pw)) issues.push("an uppercase letter");
  if (!/\d/.test(pw)) issues.push("a number");
  if (!/[^\w\s]/.test(pw)) issues.push("a symbol");
  return issues;
}

export const NAME_RE = /^[\p{L}\p{M}][\p{L}\p{M} .,'-]{0,39}$/u;        // 1–40 chars
export const COUNTRY_RE = /^[\p{L}\p{M}][\p{L}\p{M} .,'-]{0,55}$/u;     // 1–56 chars
export const CITY_RE = /^[\p{L}\p{M}][\p{L}\p{M} .,'-]{0,59}$/u;        // 1–60 chars
export const GENDER_OTHER_RE = /^[\p{L}\p{M}0-9 .,'-/]{1,40}$/u;        // 1–40 chars, relaxed

export const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
export function isValidISODate(d: string): boolean {
  if (!ISO_DATE_RE.test(d)) return false;
  const [y, m, day] = d.split("-").map(Number);
  if (y < 1900 || y > 2100) return false;
  const dt = new Date(Date.UTC(y, m - 1, day));
  return (
    dt.getUTCFullYear() === y &&
    dt.getUTCMonth() === m - 1 &&
    dt.getUTCDate() === day
  );
}


export type GenderOption = "" | "Female" | "Male" | "Prefer not to say" | "Other";